export default __webpack_public_path__ + "static/media/searchIcon.1618c90f.svg";